module.exports = __webpack_public_path__ + "static/41-53020fe7bd58cae8db4f1a397f6cfb37.png";